export default __webpack_public_path__ + "static/media/Punto_Benvenuto_DEU_Def.6ea427f0.aac";